/* global ajax_object */

// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/menu.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import { jarallax, jarallaxElement } from 'jarallax';

// import ScrollOut from 'scroll-out';
/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

const setHeaderHeight = () => {
  const header = document.querySelector('.header');

  if (header) {
    document.body.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  }
  console.log(`${header.offsetHeight}px`);
};

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  $('.testimonials-list').slick({
    infinite: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
  });
  /**
   * Accordion
   */
  $('.accordion__title').each(function () {
    // Initialize aria-expanded based on active class
    const $this = $(this);
    const $accordionItem = $this.closest('.accordion__item');
    const expanded = $accordionItem.hasClass('active') ? 'true' : 'false';
    $this.attr('aria-expanded', expanded);
  });

  $('.accordion__title').on('click', function () {
    const $this = $(this);
    const $accordionItem = $this.closest('.accordion__item');
    const $accordionContent = $accordionItem.find('.accordion__content');

    if ($accordionItem.hasClass('active')) {
      $accordionContent.slideUp(300, function () {
        $accordionItem.removeClass('active');
        $this.attr('aria-expanded', 'false');
      });
    } else {
      // Close other open accordion items
      $this
        .closest('.accordion')
        .find('.accordion__item.active .accordion__content')
        .slideUp(300, function () {
          const $parentItem = $(this).closest('.accordion__item');
          $parentItem.removeClass('active');
          $parentItem.find('.accordion__title').attr('aria-expanded', 'false');
        });

      // Open the clicked accordion item
      $accordionContent.slideDown(300, function () {
        $accordionItem.addClass('active');
        $this.attr('aria-expanded', 'true');
      });
    }
  });

  // Allow Enter and Space to toggle the accordion when the title (button) is focused

  $(document).on('keydown', '.accordion__title', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  $('.gallery-item')
    .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
    .attr('rel', 'gallery')
    .attr('data-fancybox', 'gallery');
  $(
    '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  ).fancybox({
    minHeight: 0,
    helpers: {
      overlay: {
        locked: false,
      },
    },
  });

  /**
   * Init parallax
   */
  jarallaxElement();
  jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.5,
  });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   threshold: 0.5,
  //   once: true,
  //   onShown: function (element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function (i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function () {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  $('.how-works__item').hover(function () {
    const selectedIndex = $(this).data('index');

    $('.how-works__item').removeClass('active-image');

    $(this).addClass('active-image');

    $('.how-works__image').removeClass('active-image');

    $(`.how-works__image[data-index="${selectedIndex}"]`).addClass(
      'active-image'
    );
  });

  if ($('.how-works__item').length > 0) {
    $('.how-works__item').first().trigger('click');
  }

  resizeVideo();

  $('.open-list').click(function () {
    $(this).toggleClass('opened');
    $('.list-dropdown').toggleClass('opened');
  });

  (function ($) {
    let selectedCats = [];

    // Update selected categories display
    function renderPickedCategories() {
      const container = $('#pickedCategories');
      container.html('');

      selectedCats.forEach((catId) => {
        // Find the div with matching data-id
        const catName = $(`.category-checkbox[data-id="${catId}"]`).data(
          'name'
        );
        container.append(`
            <span class="picked-item" data-id="${catId}">
                ${catName} <span class="remove-picked" data-id="${catId}"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
  <path d="M0.353516 0.353546L12.3535 12.3535" stroke="black"/>
  <path d="M12.3535 0.353546L0.353516 12.3535" stroke="black"/>
</svg></span>
            </span>
        `);
      });
    }

    // AJAX load posts
    function loadPosts(page = 1) {
      $.ajax({
        url: ajax_object.ajax_url, // <-- use ajax_object
        type: 'POST',
        data: {
          action: 'filter_posts',
          categories: selectedCats,
          paged: page,
          nonce: ajax_object.nonce, // optional, if you want nonce verification
        },
        beforeSend: function () {
          $('#blogPostsWrapper').addClass('loading');
        },
        success: function (response) {
          $('#blogPostsWrapper').html(response.posts);
          $('#ajaxPagination').html(response.pagination);
          $('#blogPostsWrapper').removeClass('loading');
          $('.matchHeight').matchHeight();
        },
      });
    }

    // Apply filter button
    // $('#applyFilterBtn').on('click', function () {
    //   selectedCats = $('.category-checkbox:checked')
    //     .map(function () {
    //       return $(this).val();
    //     })
    //     .get();
    //
    //   renderPickedCategories();
    //   loadPosts();
    // });

    // Toggle category selection on click
    $(document).on('click', '.category-checkbox', function () {
      const catId = $(this).data('id');

      if (selectedCats.includes(catId)) {
        selectedCats = selectedCats.filter((id) => id != catId);
        $(this).removeClass('selected');
      } else {
        selectedCats.push(catId);
        $(this).addClass('selected');
      }
    });

    // Apply filter button
    $('#applyFilterBtn').on('click', function () {
      // Send selectedCats via AJAX
      $('.open-list').removeClass('opened');
      $('.list-dropdown').removeClass('opened');
      loadPosts(); // your existing AJAX function
      renderPickedCategories(); // updates column 2
    });

    // Remove picked category
    $(document).on('click', '.remove-picked', function () {
      const catId = $(this).data('id');

      selectedCats = selectedCats.filter((id) => id != catId);
      $(`.category-checkbox[value="${catId}"]`).prop('checked', false);
      $('.category-checkbox').removeClass('selected');

      renderPickedCategories();
      loadPosts();
    });

    // Reset button
    $('#resetFilterBtn').on('click', function () {
      selectedCats = [];
      $('.category-checkbox').removeClass('selected');
      // $('.category-checkbox').prop('checked', false);
      $('#pickedCategories').empty();
      loadPosts();
    });

    // AJAX Pagination click
    $(document).on('click', '.ajax-page', function (e) {
      e.preventDefault();
      const page = $(this).data('page');
      loadPosts(page);
    });
  })(jQuery);
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  /**
   * Create CSS variable for header height
   */
  setHeaderHeight();
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  resizeVideo();

  /**
   * Create CSS variable for header height
   */
  setHeaderHeight();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  if ($(this).scrollTop() > 10) {
    $('.header').css({ backgroundColor: '#e3f0ff' }, 400);
  } else {
    $('.header').css({ backgroundColor: 'rgba(0,0,0,0)' }, 400);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.submenu-toggle').forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();

      const parent = this.closest('.has-dropdown');
      const submenu = parent.querySelector('.menu.submenu');
      const expanded = this.getAttribute('aria-expanded') === 'true';

      this.setAttribute('aria-expanded', !expanded);
      parent.classList.toggle('submenu-open');

      if (submenu) {
        submenu.style.maxHeight = expanded ? null : submenu.scrollHeight + 'px';
      }
    });
  });
});
